import {
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  SortingState,
  useReactTable,
} from '@tanstack/react-table';
import { useMemo, useState } from 'react';
import useMeasure from 'react-use-measure';

import { ClientTableLayout } from 'shared/ui';
import { useClientPagination, useTablePageSize } from 'shared/lib';

import { CarBrandListItem, CarModelListItem } from 'entities/car';

import { useColumns } from '../hooks/use-columns';

type Props = {
  tableData: Array<CarModelListItem>;
  loading: boolean;
  carBrands: Array<CarBrandListItem>;
  rowsCount: number | undefined;
};

export function CarModelsTableInstance({
  tableData,
  loading,
  carBrands,
  rowsCount,
}: Props) {
  const [tableHeadRef, tableHeadBounds] = useMeasure();

  const columns = useColumns({ carBrands });

  const [sorting, setSorting] = useState<SortingState>([]);
  const [tablePageSize, setTablePageSize] = useTablePageSize(tableHeadBounds);
  const [pagination, setPagination] = useClientPagination(tablePageSize);

  const data = useMemo(() => tableData, [tableData]);

  const table = useReactTable({
    data,
    columns,
    state: { sorting, pagination },
    onSortingChange: setSorting,
    onPaginationChange: setPagination,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });

  return (
    <ClientTableLayout
      table={table}
      tableHeadRef={tableHeadRef}
      handlePageSizePressEnter={setTablePageSize}
      pageSize={tablePageSize}
      loading={loading}
      rowsCount={rowsCount}
    />
  );
}
